export const LiveEndpoints = {
  getWebinars: (id: number) => `rest/v2/webinar/collection/${id}`
}

export const WEBINAR_PAGE_SIZE = 50
